import { createContext, useState, useRef } from "react";

const TemplateContractsContext = createContext();
const TemplateContractsContextProvider = ({ children }) => {
  const [modelId, setModelId] = useState(null);
  const [mainLoading, setMainLoading] = useState(false);
  const [routine, setRoutine] = useState("");
  const [contractDescription, setContractDescription] = useState("");
  const [headerEditor, setHeaderEditor] = useState("");
  const [headerDesign, setHeaderDesign] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [bodyDesign, setBodyDesign] = useState("");
  const [disabledEditor, setDisabledEditor] = useState(false);
  const [active, setActive] = useState(true);
  const [showCompanies, setShowCompanies] = useState(false);
  const [tagListBody, setTagListBody] = useState([]);
  const [tagListHeader, setTagListHeader] = useState([]);
  const emailEditorHeader = useRef(null);
  const emailEditorBody = useRef(null);
  const [errorsSubmit, setErrorsSubmit] = useState({});
  const [exportDataEditor, setExportDataEditor] = useState({});
  const [layoutContract, setLayoutContract] = useState({
    label: "Contrato",
    value: "contract",
  });

  return (
    <TemplateContractsContext.Provider
      value={{
        mainLoading,
        setMainLoading,
        routine,
        setRoutine,
        contractDescription,
        setContractDescription,
        headerEditor,
        setHeaderEditor,
        companyList,
        setCompanyList,
        disabledEditor,
        setDisabledEditor,
        active,
        setActive,
        modelId,
        setModelId,
        showCompanies,
        setShowCompanies,
        tagListBody,
        setTagListBody,
        tagListHeader,
        setTagListHeader,
        emailEditorHeader,
        emailEditorBody,
        errorsSubmit,
        setErrorsSubmit,
        headerDesign,
        setHeaderDesign,
        bodyDesign,
        setBodyDesign,
        exportDataEditor,
        setExportDataEditor,
        layoutContract,
        setLayoutContract,
      }}
    >
      {children}
    </TemplateContractsContext.Provider>
  );
};

export { TemplateContractsContextProvider, TemplateContractsContext };
